import { render, staticRenderFns } from "./Solicitud.vue?vue&type=template&id=318f28f0&scoped=true"
import script from "./Solicitud.vue?vue&type=script&lang=js"
export * from "./Solicitud.vue?vue&type=script&lang=js"
import style0 from "./Solicitud.vue?vue&type=style&index=0&id=318f28f0&prod&lang=css"
import style1 from "./Solicitud.vue?vue&type=style&index=1&id=318f28f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318f28f0",
  null
  
)

export default component.exports